var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseApiClient from '@/plugins/apis/v2/base-api-client';
var DailyReportApiClient = /** @class */ (function (_super) {
    __extends(DailyReportApiClient, _super);
    function DailyReportApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DailyReportApiClient.prototype.basePath = function (_a) {
        var projectId = _a.projectId, scheduleId = _a.scheduleId;
        var companyId = this.companyId;
        return "/companies/" + companyId + "/projects/" + projectId + "/schedules/" + scheduleId + "/daily_reports";
    };
    DailyReportApiClient.prototype.index = function (projectId, scheduleId, smallProcessId) {
        var client = this.client;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId });
        var params = {
            small_process_id: smallProcessId
        };
        return client.get(url, { params: params });
    };
    DailyReportApiClient.prototype.create = function (projectId, scheduleId, smallProcessId) {
        var requestAction = this.requestAction;
        var url = this.basePath({ projectId: projectId, scheduleId: scheduleId });
        return requestAction({
            url: url,
            data: {
                daily_report: {
                    small_process_id: smallProcessId
                }
            },
            resourceName: 'daily_report',
            actionName: 'POST',
            notice: false
        });
    };
    DailyReportApiClient.prototype.update = function (payload) {
        var requestAction = this.requestAction;
        var baseUrl = this.basePath({ projectId: payload.projectId, scheduleId: payload.scheduleId });
        var url = baseUrl + "/" + payload.id;
        var form = new FormData();
        form.append('small_process_id', payload.smallProcessId);
        form.append('daily_report[body]', payload.body);
        form.append('daily_report[draft]', payload.draft ? '1' : '0');
        if (payload.before_image_id) {
            form.append('daily_report[before_image_id]', payload.before_image_id || '');
        }
        if (payload.after_image_id) {
            form.append('daily_report[after_image_id]', payload.after_image_id || '');
        }
        if (Number.isInteger(payload.progress)) {
            form.append('daily_report[progress]', String(payload.progress));
        }
        return requestAction({
            url: url,
            method: 'put',
            data: form,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            resourceName: 'daily_report',
            actionName: 'UPDATE',
            notice: false
        });
    };
    DailyReportApiClient.prototype.attach = function (params) {
        var requestAction = this.requestAction;
        var baseUrl = this.basePath({ projectId: params.projectId, scheduleId: params.scheduleId });
        var url = baseUrl + "/" + params.id;
        return requestAction({
            url: url,
            method: 'post',
            data: {
                before_image_id: params.before_image_id,
                after_image_id: params.after_image_id
            },
            resourceName: 'daily_report',
            actionName: 'UPDATE',
            notice: false
        });
    };
    return DailyReportApiClient;
}(BaseApiClient));
export default new DailyReportApiClient();
